export class Upfront {
  constructor(
    public readonly currency: string,
    public readonly amount: number,
  ) {
  }
}